import {createStore} from 'vuex'
import {formatNumber} from "../functions"

// noinspection JSCheckFunctionSignatures
export default createStore({
    state() {
        return {
            products: [],

            initialized: false,
        }
    },
    actions: {
        initialize: ({state}, products) => {
            if (state.initialized) {
                return;
            }

            state.products = products

            state.initialized = true
        },
        changeProduct: ({dispatch, commit, getters}, product) => {
            return new Promise((resolve, reject) => {
                BX.ajax.runAction('palladiumlab:http.BasketController.changeOffer', {
                    data: {
                        fromId: product.fromId,

                        toId: product.toId,
                        quantity: product.quantity,

                        baseProductId: product.productId,
                    }
                })
                    .then(response => {
                        let oldProduct = getters.getProductById(product.fromId)
                        if (oldProduct) {
                            commit('removeProduct', product.fromId)
                        }

                        let existedProduct = getters.getProductById(product.toId)
                        if (!existedProduct) {
                            commit('addProduct', {id: product.toId, ...product})
                        } else {
                            commit('updateQuantity', {
                                id: existedProduct.id,
                                quantity: product.quantity,
                            })
                        }

                        resolve(response)
                    })
                    .catch(response => reject(response))
            })
        },
        addProduct: ({dispatch, commit, getters}, product) => {
            return new Promise((resolve, reject) => {
                BX.ajax.runAction('palladiumlab:http.BasketController.add', {
                    data: {
                        id: product.id,
                        quantity: product.quantity,

                        baseProductId: product.productId || 0,
                        price: product['customPrice'] || 0,

                        isSpecial: (product['isSpecial'] || false) ? 'Y' : 'N',
                    }
                })
                    .then(response => {
                        let existedProduct = getters.getProductById(product.id)

                        if (!existedProduct) {
                            commit('addProduct', product)
                        } else {
                            commit('updateQuantity', {
                                id: existedProduct.id,
                                quantity: existedProduct.quantity + product.quantity,
                            })
                        }

                        resolve(response)
                    })
                    .catch(response => reject(response))
            })
        },
        removeProduct: ({dispatch, commit}, id) => {
            return new Promise((resolve, reject) => {
                BX.ajax.runAction('palladiumlab:http.BasketController.delete', {data: {id}})
                    .then(response => {
                        commit('removeProduct', id)

                        resolve(response)
                    })
                    .catch(response => reject(response))
            })
        },
        updateQuantity: ({dispatch, commit}, updatedProduct) => {
            return new Promise((resolve, reject) => {
                BX.ajax.runAction('palladiumlab:http.BasketController.setQuantity', {
                    data: {
                        id: updatedProduct.id,
                        quantity: updatedProduct.quantity,
                    }
                })
                    .then(response => {
                        commit('updateQuantity', updatedProduct);

                        resolve(response);
                    })
                    .catch(response => reject(response));
            })
        },
        clear: ({commit}) => {
            return new Promise((resolve, reject) => {
                BX.ajax.runAction('palladiumlab:http.BasketController.clear')
                    .then(response => {
                        commit('clear')

                        resolve(response)
                    })
                    .catch(response => reject(response))
            })
        }
    },
    mutations: {
        addProduct: (state, product) => state.products.push(product),

        removeProduct: (state, productId) =>
            state.products = state.products.filter(product => Number(product.id) !== Number(productId)),

        updateQuantity: (state, updatedProduct) => state.products = state.products.map(product => {
            if (Number(product.id) === Number(updatedProduct.id)) {
                product.quantity = updatedProduct.quantity
            }

            return product
        }),

        clear: state => state.products = [],
    },
    getters: {
        getProductByBaseId: state => id => state.products.find(product => Number(product.baseProductId) === Number(id)),
        getProductById: state => id => state.products.find(product => Number(product.id) === Number(id)),

        productInBasket: (state, getters) => id => !!getters.getProductById(id),

        isEmpty: state => !state.products.length,

        summary: state => state.products.reduce(
            (summary, product) => summary + (Number(product.price || 0) * (product.quantity || 0)), 0
        ),
        summaryFormatted: (state, getters) => `${formatNumber(getters.summary)}`,

        count: state => state.products.length,
        quantity: state => state.products.reduce((quantity, product) => quantity + (product.quantity || 0), 0),

        weight: state => state.products.reduce(
            (weight, product) => weight + Number((product.weight || 0) * (product.quantity || 0)), 0
        ),

        discount: state => state.products.reduce(
            (discount, product) => discount + (Number(product.discount || 0) * (product.quantity || 0)), 0
        ),
        discountFormatted: (state, getters) => `${formatNumber(getters.discount)}`,

        initialized: state => () => new Promise((resolve) => {
            let interval;

            interval = setInterval(function () {
                if (state.initialized) {
                    resolve()

                    clearInterval(interval)
                }
            }, 100)
        }),
    }
})
